define('shared/initializer/form/adapters/mixins/LeadIDSubmittable',[
    '$',
    'shared/lib/RSVP',
    'shared/util/dispatchers/FormDataDispatcher'
], 
function (
    $,
    RSVP,
    FormDataDispatcher
) {
    'use strict';

    function doIt() {
        var me = this;

        if (me._leadIDSubmittableExecuted) {
            return;
        }

        return RSVP.resolve()
            .then(function(){

                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch(
                    {
                        items:
                        {
                            'omniture.name':
                            {
                                sources:
                                [{
                                    type: 'state',
                                    key: 'form.lead_id',
                                    allowUndefined: true
                                }],
                                targets:
                                [{
                                    type: 'form',
                                    key: 'lead_id'
                                }],
                                allowUndefined: true
                            }
                        },
                        timeout: 1 * 1000
                    })
                    .then(function(){
                        me._leadIDSubmittableExecuted = true;
                    });
            });
    }

    function Ctor(){
        var me = this;
        me._leadIDSubmittableExecuted = false;
        me.on('beforePersistable', function(result){
            result.promise = doIt.call(me);
        });
    }

    var p = Ctor.prototype;
    p.doBeforeSubmit = doIt;

    return Ctor;
});
